var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="custom_empty"> <div class="content-wrapper" data-help="custom"> <div class="row"> <div class="col-sm-9"> <div class="row"> <div class="col-sm-12 pr-0"> <h3 class="text-dark font-weight-bold mb-0 mr-5">'+
((__t=( resources['X200428'] ))==null?'':__t)+
'</h3> </div> </div> </div> </div> <div class="row mt-3"> <div class="col-12 grid-margin stretch-card"> <div class="card"> <div class="card-body"> <div id="customInformation" class="e4usInformation" style="display:none"></div> <h4 class="card-title">'+
((__t=( resources['X200428'] ))==null?'':__t)+
'</h4> <form class="forms-sample"> <div class="control-group custom_inputFriendlyUrl"> <div class="form-group"> <label id="custom_labelName" for="custom_inputFriendlyUrl">'+
((__t=( resources['X200428'] ))==null?'':__t)+
'</label> <input class="form-control form-control-sm" value="'+
((__t=( model.FriendlyUrl))==null?'':__t)+
'" id="custom_inputFriendlyUrl" maxlength="255"> <span class="form-control-feedback help-inline" style="color:red"></span> </div> </div> <button type="button" class="btn btn-primary btn-sm" id="custom_btnSubmit">'+
((__t=( resources['X200059'] ))==null?'':__t)+
'</button> </form> </div> </div> </div> </div> </div> </div>';
}
return __p;
};
